export function useCommonInputProps() {
  return {
    name: { type: String, default: undefined },
    modelValue: [String, Number, Array, Boolean, Object],
    disabled: Boolean,
    readonly: Boolean,
    invalid: Boolean,
    errorMessage: { type: String, default: undefined },
    inputClass: { type: String, default: '' },
    id: { type: String, default: undefined },
    placeholder: { type: String, default: undefined },
    label: { type: String, default: undefined },
    helper: { type: String, default: undefined },
    required: Boolean,
  }
}
